var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v_shopTheLook_container cc",
      class: { "is-landscape": _vm.config.isLandscape === true },
      on: { click: _vm.onContainerClick },
    },
    [
      _vm.showMasterLink && _vm.config.masterUrl
        ? _c("a", {
            staticClass: "masterLink",
            attrs: {
              href: _vm.config.masterUrl,
              "aria-label": `STL: ${_vm.config.ariaLabel}`,
              "click-count": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMagnifier
        ? _c(
            "button",
            {
              staticClass: "magnifier",
              attrs: {
                type: "button",
                "aria-label": `Look vergroessern: ${
                  _vm.config.ariaLabel || ""
                }`,
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.emitOpenFullscreen.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "lucide lucide-zoom-in-icon lucide-zoom-in",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("circle", { attrs: { cx: "11", cy: "11", r: "8" } }),
                  _c("line", {
                    attrs: { x1: "21", x2: "16.65", y1: "21", y2: "16.65" },
                  }),
                  _c("line", {
                    attrs: { x1: "11", x2: "11", y1: "8", y2: "14" },
                  }),
                  _c("line", {
                    attrs: { x1: "8", x2: "14", y1: "11", y2: "11" },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("picture", [
        _vm.config.imageUrlMobile
          ? _c("source", {
              attrs: {
                media: "(max-width: 576px)",
                srcset: _vm.config.imageUrlMobile,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          staticClass: "shopTheLook_Image",
          attrs: {
            src: _vm.config.imageUrl,
            "aria-label": _vm.config.ariaLabel,
            alt: _vm.config.ariaLabel,
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "v_shopTheLook_tags" },
        _vm._l(_vm.visibleDots, function (entry) {
          return _c(
            "span",
            {
              key: entry.dot.id,
              staticClass: "v_shopTheLook_tag",
              class: { active: entry.dot.isOpen, notfound: !entry.dot.exists },
              style: _vm.tagStyle(entry.dot),
              attrs: { "data-idx": entry.index },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onTagClick(entry.index, $event)
                },
              },
            },
            [
              _c("span", { staticClass: "dot-marker" }),
              _vm._v(" "),
              entry.dot.isOpen && entry.dot.data
                ? _c(
                    "div",
                    {
                      staticClass: "itemInfo",
                      class: entry.dot.orientation,
                      attrs: { "aria-label": `STL: ${_vm.dotName(entry.dot)}` },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "contents stlInfo" }, [
                        _c("span", { staticClass: "manufacturer" }, [
                          _vm._v(_vm._s(_vm.manufacturerName(entry.dot))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.dotName(entry.dot))),
                        ]),
                        _vm._v(" "),
                        _vm.showPrice(entry.dot)
                          ? _c("span", { staticClass: "itemPrice" }, [
                              _c("span", { staticClass: "prices" }, [
                                _vm.hasDiscount(entry.dot)
                                  ? _c("del", { staticClass: "crossprice" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatPrice(entry.dot.data.rrp)
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      redPrice: _vm.hasDiscount(entry.dot),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatPrice(entry.dot.data.price)
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "basket",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            entry.dot.data && entry.dot.data.id
                              ? _c(
                                  "client-only",
                                  [
                                    _c("add-to-basket", {
                                      attrs: {
                                        "variation-id": entry.dot.variationId,
                                        "is-salable": entry.dot.data.isSalable,
                                        "one-click": "",
                                        "use-large-scale": "",
                                        "show-quantity": false,
                                        "minimum-quantity": 1,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "followArrow",
                          attrs: { href: _vm.productUrl(entry.dot) },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "css-i6dzq1",
                              attrs: {
                                viewBox: "0 0 24 24",
                                width: "24",
                                height: "24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                fill: "none",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("polyline", {
                                attrs: { points: "9 18 15 12 9 6" },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }